export const filterByValues = [
    { value: "mostRecent", name: "Most recent" },
    { value: "mostDesigns", name: "Most designs" },
    { value: "leastDesigns", name: "Least designs" },
];

export const filterByDesignsValues = [
    { value: "mostRecent", name: "Default" },
    { value: "mostVoted", name: "Most votes" },
    { value: "leastVoted", name: "Least votes" },
];

export const countryMap = new Map([
    ['Estonia', 'EE'],
    ['Bulgaria', 'BG'],
    ['United Kingdom', 'UK'],
    ['Spain', 'ES'],
    ['Germany', 'DE']
  ])